"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatMerge = exports.filterIncludes = exports.simpleMerge = exports.mergeSimilar = exports.canMergeFilters = void 0;
const shared_1 = require("@snort/shared");
/**
 * Keys which can change the entire meaning of the filter outside the array types
 */
const DiscriminatorKeys = ["since", "until", "limit", "search"];
function canMergeFilters(a, b) {
    const aObj = a;
    const bObj = b;
    for (const key of DiscriminatorKeys) {
        if (aObj[key] !== bObj[key]) {
            return false;
        }
    }
    return (0, shared_1.distance)(a, b) <= 1;
}
exports.canMergeFilters = canMergeFilters;
function mergeSimilar(filters) {
    const ret = [];
    const fCopy = [...filters];
    while (fCopy.length > 0) {
        const current = fCopy.shift();
        const mergeSet = [current];
        for (let i = 0; i < fCopy.length; i++) {
            const f = fCopy[i];
            if (!mergeSet.some(v => !canMergeFilters(v, f))) {
                mergeSet.push(fCopy.splice(i, 1)[0]);
                i--;
            }
        }
        ret.push(simpleMerge(mergeSet));
    }
    return ret;
}
exports.mergeSimilar = mergeSimilar;
/**
 * Simply flatten all filters into one
 * @param filters
 * @returns
 */
function simpleMerge(filters) {
    const result = {};
    filters.forEach(filter => {
        Object.entries(filter).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                if (result[key] === undefined) {
                    result[key] = [...value];
                }
                else {
                    const toAdd = value.filter(a => !result[key].includes(a));
                    result[key].push(...toAdd);
                }
            }
            else {
                result[key] = value;
            }
        });
    });
    return result;
}
exports.simpleMerge = simpleMerge;
/**
 * Check if a filter includes another filter, as in the bigger filter will include the same results as the samller filter
 * @param bigger
 * @param smaller
 * @returns
 */
function filterIncludes(bigger, smaller) {
    const outside = bigger;
    for (const [k, v] of Object.entries(smaller)) {
        if (outside[k] === undefined) {
            return false;
        }
        if (Array.isArray(v) && v.some(a => !outside[k].includes(a))) {
            return false;
        }
        if (typeof v === "number") {
            if (k === "since" && outside[k] > v) {
                return false;
            }
            if (k === "until" && outside[k] < v) {
                return false;
            }
            // limit cannot be checked and is ignored
        }
    }
    return true;
}
exports.filterIncludes = filterIncludes;
/**
 * Merge expanded flat filters into combined concise filters
 * @param all
 * @returns
 */
function flatMerge(all) {
    let ret = [];
    // to compute filters which can be merged we need to calucate the distance change between each filter
    // then we can merge filters which are exactly 1 change diff from each other
    function mergeFiltersInSet(filters) {
        return filters.reduce((acc, a) => {
            Object.entries(a).forEach(([k, v]) => {
                if (k === "keys")
                    return;
                if (DiscriminatorKeys.includes(k)) {
                    acc[k] = v;
                }
                else {
                    acc[k] ?? (acc[k] = []);
                    if (!acc[k].includes(v)) {
                        acc[k].push(v);
                    }
                }
            });
            return acc;
        }, {});
    }
    // reducer, kinda verbose
    while (all.length > 0) {
        const currentFilter = all.shift();
        const mergeSet = [currentFilter];
        for (let i = 0; i < all.length; i++) {
            const f = all[i];
            if (mergeSet.every(a => canMergeFilters(a, f))) {
                mergeSet.push(all.splice(i, 1)[0]);
                i--;
            }
        }
        ret.push(mergeFiltersInSet(mergeSet));
    }
    while (true) {
        const n = mergeSimilar([...ret]);
        if (n.length === ret.length) {
            break;
        }
        ret = n;
    }
    return ret;
}
exports.flatMerge = flatMerge;
//# sourceMappingURL=data:application/json;base64,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